export default [
  [
    { text: 'Мебель в комнатах', model: 'hasFurniture' },
    { text: 'Мебель на кухне', model: 'hasKitchenFurniture' },
    { text: 'Холодильник', model: 'hasFridge' },
    { text: 'Посудомоечная машина', model: 'hasDishwasher' },
    { text: 'Стиральная машина', model: 'hasWasher' },
    { text: 'Можно с детьми', model: 'childrenAllowed' },
    { text: 'Можно с животными', model: 'petsAllowed' },
  ],
  [
    { text: 'Интернет', model: 'hasInternet' },
    { text: 'Телефон', model: 'hasPhone' },
    { text: 'Телевизор', model: 'hasTv' },
    { text: 'Кондиционер', model: 'hasConditioner' },
    { text: 'Ванна', model: 'hasBathtub' },
    { text: 'Душевая кабина', model: 'hasShower' },
  ],
];
